/**
 * CookieScript consent banner, loaded via code in ios and android.
 */
export const COOKIE_SCRIPT_ID = 'c2781f71048342f362c8f8cbd4084bac';

export const COOKIE_SCRIPT_URL = `https://cdn.cookie-script.com/s/${COOKIE_SCRIPT_ID}.js`;
